import { processFields } from 'utils/reader';

export default class Model {
  constructor(data) {
    this.process(data)
  }

  process(data = {}) {
    if (this.constructor.fields) {
      Object.assign(this, processFields(this.constructor.fields, data));
    } else {
      // If no fields defined assign everythig to the new instance
      Object.assign(this, data);
    }
  }
}